<div class="row row-cols-2 row-cols-md-4 counter-style-04">
  <div class="col last-paragraph-no-margin sm-mb-30px text-center">
    <div style="white-space: nowrap;">
      <h1 class="vertical-counter d-inline-flex alt-font text-black fw-300 mb-0" data-to="8" data-speed="1"></h1>
      <span style="font-size: 60px; color: black; font-weight: 300; display: inline-flex; position: relative; top: -10px;">+</span>
    </div>
    <span class="fs-13 text-base-color fw-600 d-block ls-2px text-uppercase">Years in Business</span>
  </div>

  <div class="col last-paragraph-no-margin sm-mb-30px text-center">
    <div style="white-space: nowrap;">
      <h1 class="vertical-counter d-inline-flex alt-font text-black fw-300 mb-0" data-to="500" data-speed="25"></h1>
      <span style="font-size: 60px; color: black; font-weight: 300; display: inline-flex; position: relative; top: -10px;">+</span>
    </div>
    <span class="fs-13 text-base-color fw-600 d-block ls-2px text-uppercase">Happy Customers</span>
  </div>

  <div class="col last-paragraph-no-margin text-center">
    <div style="white-space: nowrap;">
      <h1 class="vertical-counter d-inline-flex alt-font text-black fw-300 mb-0" data-to="3000" data-speed="150"></h1>
      <span style="font-size: 60px; color: black; font-weight: 300; display: inline-flex; position: relative; top: -10px;">+</span>
    </div>
    <span class="fs-13 text-base-color fw-600 d-block ls-2px text-uppercase">Projects Completed</span>
  </div>

  <div class="col last-paragraph-no-margin text-center">
    <div style="white-space: nowrap;">
      <h1 class="vertical-counter d-inline-flex alt-font text-black fw-300 mb-0" data-to="15" data-speed="1"></h1>
      <span style="font-size: 60px; color: black; font-weight: 300; display: inline-flex; position: relative; top: -10px;">+</span>
    </div>
    <span class="fs-13 text-base-color fw-600 d-block ls-2px text-uppercase">Team Strength</span>
  </div>
</div>